import { render, staticRenderFns } from "./OrmMessageViewSideMenu.vue?vue&type=template&id=4bef7913"
import script from "./OrmMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports